import { render, staticRenderFns } from "./ReviewReturn.vue?vue&type=template&id=4c07273d&scoped=true&"
import script from "./ReviewReturn.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewReturn.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewReturn.vue?vue&type=style&index=0&id=4c07273d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07273d",
  null
  
)

export default component.exports